<template>
  <notification
    :is-show-icon="false"
    type="warning"
    class="confirm-email-notification"
  >
    <p class="confirm-email-notification__desc">
      Подтвердите свой email и получите еще
      <strong>50 бонусных рублей</strong>.
    </p>
    <p class="confirm-email-notification__desc">
      Проверьте свою почту, мы отправили вам письмо.
    </p>
  </notification>
</template>

<script>
import { Notification } from '@book24/ui-components';

export default {
  name: 'ConfirmEmailNotification',
  components: {
    Notification,
  },
};
</script>
